// Hooks
import { useNavigateFromMentionsWhenNeeded } from '@/utils/hooks/conversations/useNavigateFromMentionsWhenNeeded';
import { useResetOpenedMessageOnProfileChange } from '@/utils/hooks/conversations/useResetOpenedMessageOnProfileChange';

// Components
import { PageContentWrapper } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper';
import { SocialInboxDesktop } from '@/components/pages/conversations/SocialInbox/components/SocialInboxDesktop/SocialInboxDesktop';
import { SocialInboxMobile } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMobile/SocialInboxMobile';

export const SocialInbox = () => {
    useResetOpenedMessageOnProfileChange();
    useNavigateFromMentionsWhenNeeded();

    return (
        <PageContentWrapper>
            <div className="size-full overflow-hidden rounded-t-xl bg-icoGray-300 dark:bg-icoDarkMode-beton">
                <SocialInboxMobile />
                <SocialInboxDesktop />
            </div>
        </PageContentWrapper>
    );
};
